import { useState } from 'react';
import { connect } from 'react-redux';
import { fetchBooksByKeyword } from '../store/searchBookSlice.js';
import PeriodBanner from './bookClubTabs/suggestionTab/PeriodBanner.jsx';
//import SuggestionsResults from './bookClubTabs/suggestionTab/SuggestionsResults.jsx';
import SuggestionSerchForm from './bookClubTabs/suggestionTab/SuggestionSearchForm.jsx';
import { Star, BookOpen, Trophy, X } from 'lucide-react';
//import suggestionsPagePresenter from '../presenters/suggestionsPagePresenter.jsx';
import StarRating from '../components/StarRating.jsx';

import { sortBooksByScore } from '../utils.js';
import RankedList from '../components/RankedList.jsx';
// Extrahera data från Redux state
function mapStateToProps(state) {
  return {
    user: state.user,
    bookClub: state.bookClub,
    suggestions: state.suggestions,
  };
}
// Extrahera actions/dispatch
function mapDispatchToProps(dispatch) {
  return {
  };
}
export function TestView(props) {
  const rankedSuggestions = [
    props.suggestions.suggestedBooks[0],
    props.suggestions.suggestedBooks[1],
    props.suggestions.suggestedBooks[2],
  ]; // Replace with actual ranked suggestions

  // Local search params state for form → search thunk

    function getVoteCount(bookId) {
      const bookVotes = bookClub.votes[bookId];
      return bookVotes ? Object.keys(bookVotes).length : 0;
    }
  /*  function compareBooks(a, b) {
      const avgA = getAverageRating(a.id);
      const avgB = getAverageRating(b.id);
      if (avgB !== avgA) return avgB - avgA; //Descending by average rating
    }
    function tieBreaker(a, b) {
      const votesA = getVoteCount(a.id);
      const votesB = getVoteCount(b.id);
      return votesB - votesA; //Descending by vote count
    }
    function finalComparator(a, b) {
      const avgA = getAverageRating(a.id);
      const avgB = getAverageRating(b.id);
      if (avgB !== avgA) return avgB - avgA;
      return tieBreaker(a, b);
   }*/
   function rankSuggestions() {
      return [...bookClub.suggestionsData].sort(finalComparator);
    }
   function getWinningBook() {
      const ranked = rankSuggestions();
      return ranked[0];
    }
    function updateBookClub(clubId, updates) {
      // Mock function to update book club data
      console.log(`Updating club ${clubId} with`, updates);
    }
    function isVotingActiveCheck() {
      const today = new Date();
      const deadline = new Date(bookClub.votingDeadline);
      return today <= deadline;
    }
    const isVotingActive = false; // Replace with actual check
    const hasVotingEnded = !isVotingActive;
    const isAdmin = true; // Replace with actual admin check
    const daysRemaining = 12;
    const winningBook = rankedSuggestions[0];
 //   const avgRating = winningBook ? getAverageRating(winningBook.id) : 0;
   
/*
  // Handle finalizing the vote and selecting winning book 
  const handleFinalizeVoting = () => {
    if (rankedSuggestions.length === 0) {
      alert('No suggestions to finalize.');
      return;
    }
    
    if (confirm(`Set "${winningBook.title}" (Avg Rating: ${avgRating.toFixed(1)} ⭐) as the next book?`)) {
      updateBookClub(bookClub.id, {
        currentBook: winningBook,
        suggestions: bookClub.suggestions.filter(id => id !== winningBook.id),
        previousBooks: bookClub.currentBook ? [...bookClub.previousBooks, bookClub.currentBook.id] : bookClub.previousBooks,
        memberProgress: Object.fromEntries(bookClub.members.map(id => [id, 0])),
        votingDeadline: null,
        votes: {}
      });
    }
  };
  */

  const handleVote = (bookId, rating) => {
    console.log('vote', { bookId, rating, user: currentUser.id });
  };

  const handleBookDetailConfirm = (book) => {
    console.log('add suggestion', book);
    setShowBookDetail(null);
  };
  function getTotalPoints(bookId) {

  }

  const handleStartVoting = () => {
    console.log('start voting with deadline', votingDeadline);
  };
  function StttarRating({ bookId, currentRating = 0, readonly = false, onRate }) {
    const [hoveredRating, setHoveredRating] = useState(0);
    return (
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={`w-5 h-5 cursor-pointer ${
              (hoveredRating >= star || currentRating >= star) ? 'fill-amber-400 text-amber-400' : 'text-amber-200'
            }`}
            onMouseEnter={() => !readonly && setHoveredRating(star)}
            onMouseLeave={() => !readonly && setHoveredRating(0)}
            onClick={() => !readonly && onRate(star)}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-6">

      

      {/* Ranked Suggestions - Main Focus */}
      <div>
        <h3 className="text-amber-900 mb-4">Current Suggestions</h3>
        <div className="space-y-3">
          {/* kommer rendera alla förslag från redan en sorterad lista */}
          {rankedSuggestions.map((book, index) => {
            const totalPoints = book.totalScore;
            const voteCount = book.voters.length;
            //const userRating = bookClub.votes[book.bookId]?.[currentUser.id];

            return (
              <div 
                key={book.bookId} 
                onClick={() => setShowBookDetail(book)}
                className="bg-white rounded-lg p-4 border border-amber-100 hover:shadow-md transition-shadow cursor-pointer"
              >
                <div className="flex gap-4">
                  <div className="flex items-center justify-center w-12">
                    {index === 0 && totalPoints > 0 && (
                      <Trophy className="w-6 h-6 text-amber-500 fill-amber-500" />
                    )}
                    {index !== 0 && (
                      <span className="text-amber-600">#{index + 1}</span>
                    )}
                  </div>
                  
                  <img
                    src={book.bookImg}
                    alt={book.title}
                    className="w-16 h-24 object-cover rounded shadow"
                  />
                  
                  <div className="flex-1">
                    <h4 className="text-amber-900 mb-1">{book.title}</h4>
                    <p className="text-amber-600 mb-2">{book.author}</p>
                    <div className="flex gap-2 mb-3">
                      <span className="px-2 py-1 bg-amber-100 text-amber-700 rounded text-xs">{book.genre}</span>
                      <span className="px-2 py-1 bg-amber-100 text-amber-700 rounded text-xs">{book.pages} pages</span>
                    </div>
                    
                    <StarRating
                      bookId={book.bookId}
                      currentRating={3/*users score*/}
                      readonly={!true}
                      onRate={() => {}}
                    />

                    {/* Star Rating - Only show if voting is active }
                    {true && !userRating && (
                      <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
                        <span className="text-amber-700 text-sm">Rate this book:</span>
                        <StarRating
                          bookId={book.id}
                          onRate={(rating) => handleVote(book.id, rating)}
                        />
                      </div>
                    )}
                   {/*visar användarens röst om den finns*//*}
                    {userRating && (
                      <div className="flex items-center gap-2">
                        <span className="text-amber-700 text-sm">Your rating:</span>
                        <StarRating
                          bookId={book.id}
                          currentRating={userRating}
                          readonly={!true}
                          onRate={true ? (rating) => handleVote(book.id, rating) : undefined}
                        />
                      </div>
                    )}
                    */}
                    {/* Stänger voting möjligheten */}
                    {!true && !userRating && (
                      <p className="text-amber-600 text-sm italic">Voting period not active</p>
                    )}
                  </div>

                  <div className="flex flex-col items-end gap-3">
                    <div className="text-center">
                      {voteCount > 0 ? (
                        <>
                          <div className="flex items-center gap-1 mb-1">
                            <Star className="w-5 h-5 fill-amber-400 text-amber-400" />
                            <span className="text-amber-900">{totalPoints}</span>
                          </div>
                          <div className="text-xs text-amber-600">{voteCount} vote{voteCount !== 1 ? 's' : ''}</div>
                        </>
                      ) : (
                        <div className="text-xs text-amber-400">No votes yet</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

          {rankedSuggestions.length === 0 && (
            <div className="text-center py-12 bg-amber-50 rounded-xl border border-amber-100">
              <BookOpen className="w-12 h-12 text-amber-300 mx-auto mb-3" />
              <p className="text-amber-600">
                {isVotingActive 
                  ? 'No book suggestions yet. Be the first to suggest one!' 
                  : 'No active voting period. Admin can start a new voting period below.'}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Add Suggestion with Search - Only show if voting is active */}


     

      {/* Start New Voting Period (Admin) }
      {true && (
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border border-amber-200">
          <div className="flex items-center gap-4">
            <Calendar className="w-6 h-6 text-amber-600 flex-shrink-0" />
            <div className="flex-1">
              <h3 className="text-amber-900 mb-2">{!isVotingActive? 'Start new ' : 'Update '}  voting Period </h3>
              <p className="text-amber-700 mb-4">
                Set a deadline for members to suggest and vote on books.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <input
                type="date"
                value={votingDeadline}
                onChange={(e) => setVotingDeadline(e.target.value)}
                className="px-3 py-2 border border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
                min={new Date().toISOString().split('T')[0]}
              />
              <button
                onClick={handleStartVoting}
                className="px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-600 text-white rounded-lg hover:from-amber-600 hover:to-orange-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                Start Voting
              </button>
            </div>
          </div>
        </div>
      )}*/}
      <RankedList rankedSuggestions={rankedSuggestions} bookClub={props.bookClub} currentUser={props.user} setShowBookDetail={() => {}} />
    
    
    </div>
  );

}
export default connect(mapStateToProps, mapDispatchToProps)(TestView);

